import { combineReducers } from "redux";
import { userReducer } from "./user";
import attendanceReducer from './checks';
import leaveReducer from "./leave";
import requestReducer from "./request";
import announcementReducer from './announcements'
import holidayReducer from './holidays'
export const rootReducer = combineReducers({
    user: userReducer,
    leave: leaveReducer,
    request: requestReducer,
    attendance: attendanceReducer,
    announcement: announcementReducer,
    holidays: holidayReducer
});